module.exports = __webpack_public_path__ + "static/img/create_circle.3628a6f7.png";